

























import Vue, { PropType } from 'vue'
import Message, { MessageSendType } from '@/types/Message.interface'
import SmsCommentBubble from '@/components/SmsCommentBubble.vue'
import SmsInboundBubble from '@/components/SmsInboundBubble.vue'
import SmsOutboundBubble from '@/components/SmsOutboundBubble.vue'
export default Vue.extend({
    components: { SmsCommentBubble, SmsInboundBubble, SmsOutboundBubble },
    props: {
        filtered: {
            type: Array as PropType<Message[]>,
            default: null
        },
        //  Determines if we are currently switching filters for messages
        filtering: {
            type: Boolean,
            default: false
        },
        //  Determines if the loading spinner is shown at the top of the message feed (used to display pagination)
        loading: {
            type: Boolean,
            default: false
        },
        //  The messages displayed
        messages: {
            type: Array as PropType<Message[]>,
            required: true
        }
    },
    data() {
        return {
            paginationCounter: 0,
        }
    },
    //  We use updated instead of mounted() + this.$nexstTick() here becuase the component gets rendered by the parent component
    //  and thus when we call scrollToItem() the element will be null even with the nextTick becuase nextTick sees the component as updated on the DOM and thus executes 
    //  even though the list isn't initilized yet as it's waiting for the parent component update, not a DOM update for the items it should render which is what nextTick() looks for \
    //  Due to this we need to modify our query parameters as well in the scroll function, more described there
    updated() {
        this.scrollToItem()
    },
    computed: {
        filteredMessages(): Message[] {
            //  Grab our current filter type
            const type = this.messageType

            //  If our type is 'all' then display messages
            if (type === 'channel') return this.messages
            //  Else, display our filtered messages
            else return this.filtered
        },
        //  The model bound to our filter toggle
        messageType(): MessageSendType {
            return this.$store.getters.inboxMessageType
        },
        showMore(): boolean {
            //  Grab our current route
            const route = this.$route.path

            //  Our type depends on the route
            const type = route.substring(1)

            //  Create our identifier
            const identifier = `${type}TriPanel`

            //  Grab our triPanel
            const triPanel = this.$store.getters.triPanel(identifier)

            //  If it doesn't exist, return false
            if (!triPanel) return false

            //  Else, grab the showMore value
            const showMore = triPanel.showMore

            //  Return this value
            return showMore
        },
        //  Determines if the messages panel is shown
        visible(): boolean {
            //  If we are filtering, then return false
            if (this.filtering) return false

            //  Grab our type
            const type = this.messageType

            //  If we are filtered, our condition depends on the filtered array
            if (type !== 'channel') return this.filtered && this.filtered.length > 0
            //  Else, it depends on messages
            else return this.messages && this.messages.length > 0
        }
    },
    methods: {
        scrollToItem(): void {
            //  Grab our query parameters if the user is navigating here from our messages search
            const item = this.$route.query.item
            const type = this.$route.query.filter

            //  If we also have the type query parameter we update our message filters to show the type the user wishes to see, for example 
            //  instead of seeing all messages they will see the scheduled messages filter if they clicked on a schedules message
            if (type) {
                this.$store.commit('inboxMessageTypeSet', type)
            }

            //  We add some manual protection to prevent infinite recursion. In theory this infinite recursion would never happen since any message clicked on in our search must exist
            //  and has to be in the last 30 days meaning it shouldn't be too far in the list. However, due to infinite recursion breaking the app for the user if it happens it's better to just prevent 
            //  it. Since we paginate 30 items per page this means we can paginate at most 1000 messages per channel. I think this is more than enough and anything beyond this would get laggy anyways
            if (this.paginationCounter > 35) return

            //  If we passed an item index for our query param then we need to scroll to the message id provided
            if (item) {
                //  Scroll to the item with the corresponding ID
                let element = document.getElementById(`${item}`);

                //  If we are looking for an item but couldn't find it then we need to paginate as it's on another page, we emit to Inbox.vue to paginate the next number of messages.
                if (!element) {
                    this.$emit('paginate', true)
                    element = document.getElementById(`${item}`);
                }
               
                if (element) {
                    //  Since our element is now rendered we can scroll to it
                    element.scrollIntoView({ behavior: 'smooth' });

                    //  Since this function is called per update we need to remove our query parameters after we do the initial scroll otherwise any channel update will trigger the scroll method and cause the user to
                    //  be scrolled to the initial message they wanted to get to in the channel. See notes above the updated() function to learn more about why we have to do this
                    let updatedQuery = { ...this.$route.query };

                    //  Remove the specific query parameters 
                    delete updatedQuery['item'];
                    delete updatedQuery['filter'];

                    //  Use router's push or replace method to update the URL without reloading the page
                    this.$router.push({ query: updatedQuery });
                }
                
                //  Increase the number of paginations that have occured to prevent an infinite recursion
                this.paginationCounter++
            }
        },
    }
})
